import { string, object, SchemaOf } from 'yup'

export interface IRecoveryCodeSchema {
    code: string
}

const recoveryCodeSchema: SchemaOf<IRecoveryCodeSchema> = object().shape({
    code: string().max(6, 'Código inválido.').required('Preencha o campo com o código enviado para o seu e-mail.'),
})

export default recoveryCodeSchema
